import { render, staticRenderFns } from "./sugestions.vue?vue&type=template&id=6ddca8bd&scoped=true&lang=html&"
import script from "./sugestions.vue?vue&type=script&lang=js&"
export * from "./sugestions.vue?vue&type=script&lang=js&"
import style0 from "./sugestions.vue?vue&type=style&index=0&id=6ddca8bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddca8bd",
  null
  
)

export default component.exports